"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactFontawesome = require("@fortawesome/react-fontawesome");

var _fontawesomeSvgCore = require("@fortawesome/fontawesome-svg-core");

var _freeBrandsSvgIcons = require("@fortawesome/free-brands-svg-icons");

var _index = require("./index.style");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

_fontawesomeSvgCore.library.add(_freeBrandsSvgIcons.faLinkedinIn, _freeBrandsSvgIcons.faYoutube, _freeBrandsSvgIcons.faFacebookF, _freeBrandsSvgIcons.faInstagram, _freeBrandsSvgIcons.faTwitter);

var JukinFooter =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(JukinFooter, _PureComponent);

  function JukinFooter() {
    _classCallCheck(this, JukinFooter);

    return _possibleConstructorReturn(this, _getPrototypeOf(JukinFooter).apply(this, arguments));
  }

  _createClass(JukinFooter, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          funkUrl = _this$props.funkUrl,
          analytics = _this$props.analytics,
          message = _this$props.message;
      var copyright = new Date().getFullYear();
      var isProd = funkUrl === "https://funk-qa.jukinmedia.com" ? false : true;
      return _react["default"].createElement(_index.FooterContainer, null, _react["default"].createElement("div", {
        className: "flex"
      }, _react["default"].createElement("div", {
        className: "copyright"
      }, _react["default"].createElement("img", {
        src: "https://i.imgur.com/QMVRNv4.png",
        style: {
          width: '50px',
          height: '50px',
          marginTop: '60px'
        },
        className: "logo"
      }), _react["default"].createElement("p", null, "\xA9 ", copyright, " ", _react["default"].createElement("a", {
        onClick: function onClick() {
          return analytics("send", "event", message, "JM link");
        },
        className: "footerCopyright",
        href: funkUrl,
        title: "Trusted Media Brands",
        target: "_blank",
        rel: "noopener noreferrer"
      }, "Trusted Media Brands"))), _react["default"].createElement("div", null, _react["default"].createElement("h3", null, "Licensing"), _react["default"].createElement("ul", null, _react["default"].createElement("li", null, _react["default"].createElement("a", {
        className: `customer-support footerUrl`,
        onClick: function onClick() {
          return analytics("send", "event", message, "Advertising");
        },
        target: "_blank",
        href: "https://campaign.jukinmedia.com/jmlicensing"
      }, "Advertising")), _react["default"].createElement("li", null, _react["default"].createElement("a", {
        className: `faq footerUrl`,
        onClick: function onClick() {
          return analytics("send", "event", message, "Film & TV");
        },
        target: "_blank",
        href: "https://campaign.jukinmedia.com/entertainment"
      }, "Film & TV")), _react["default"].createElement("li", null, _react["default"].createElement("a", {
        className: `infringement-form footerUrl`,
        onClick: function onClick() {
          return analytics("send", "event", message, "Publishing");
        },
        href: "".concat(funkUrl, "/licensing/reported-infringement")
      }, "Publishing")), _react["default"].createElement("li", null, _react["default"].createElement("a", {
        onClick: function onClick() {
          return analytics("send", "event", message, "IP Form");
        },
        className: `footerUrl`,
        href: isProd ? "https://partner.jukinmedia.com/licensing/reported-infringement" : "https://partner-qa.jukinmedia.com/licensing/reported-infringement",
        rel: "noopener noreferrer"
      }, "IP Form")), _react["default"].createElement("li", null, _react["default"].createElement("a", {
        onClick: function onClick() {
          return analytics("send", "event", message, "Submit Inquiry");
        },
        className: `footerUrl`,
        href: "https://www.jukinmedia.com/licensing/inquiry"
      }, "Submit Inquiry")))), _react["default"].createElement("div", null, _react["default"].createElement("h3", null, "Earn"), _react["default"].createElement("ul", null, _react["default"].createElement("li", null, _react["default"].createElement("a", {
        onClick: function onClick() {
          return analytics("send", "event", message, "Submit Video");
        },
        className: `footerUrl`,
        href: "https://www.jukinmedia.com/video-submissions",
        rel: "noopener noreferrer"
      }, "Submit Video")), _react["default"].createElement("li", null, _react["default"].createElement("a", {
        onClick: function onClick() {
          return analytics("send", "event", message, "Work With Us");
        },
        className: `footerUrl`,
        href: "https://www.jukinmedia.com/why-work-with-jukin",
        rel: "noopener noreferrer"
      }, "Work With Us")), _react["default"].createElement("li", null, _react["default"].createElement("a", {
        onClick: function onClick() {
          return analytics("send", "event", message, "Partner Dashboard");
        },
        className: `footerUrl`,
        href: "https://partner.jukinmedia.com/",
        target: "_blank",
        rel: "noopener noreferrer"
      }, "Partner Dashboard")), _react["default"].createElement("li", null, _react["default"].createElement("a", {
        onClick: function onClick() {
          return analytics("send", "event", message, "Partner Support");
        },
        className: `footerUrl`,
        href: "mailto:partnersupport@jukinmedia.com",
        target: "_blank",
        rel: "noopener noreferrer"
      }, "Partner Support")), _react["default"].createElement("li", null, _react["default"].createElement("a", {
        onClick: function onClick() {
          return analytics("send", "event", message, "WeatherSpy");
        },
        className: `footerUrl`,
        href: "https://www.weatherspy.tv/",
        target: "_blank",
        style: {
          display: 'none'
        },
        rel: "noopener noreferrer"
      }, "WeatherSpy")))), _react["default"].createElement("div", null, _react["default"].createElement("h3", null, "Support"), _react["default"].createElement("ul", null, _react["default"].createElement("li", null, _react["default"].createElement("a", {
        className: "terms",
        onClick: function onClick() {
          return analytics("send", "event", message, "FAQ");
        },
        className: `footerUrl`,
        href: "https://www.jukinmedia.com/licensing/faq",
        rel: "noopener noreferrer"
      }, "FAQ")), _react["default"].createElement("li", null, _react["default"].createElement("a", {
        onClick: function onClick() {
          return analytics("send", "event", message, "Licensing Support");
        },
        className: `footerUrl`,
        href: "mailto:customersupport@jukinmedia.com",
        target: "_blank",
        rel: "noopener noreferrer"
      }, "Licensing Support")), _react["default"].createElement("li", null, _react["default"].createElement("a", {
        onClick: function onClick() {
          return analytics("send", "event", message, "Privacy Policy");
        },
        className: `footerUrl`,
        href: "https://www.jukinmedia.com/privacy-policy",
        rel: "noopener noreferrer"
      }, "Privacy Policy"))), _react["default"].createElement("li", null, _react["default"].createElement("a", {
        className: "terms",
        onClick: function onClick() {
          return analytics("send", "event", message, "Term");
        },
        className: `footerUrl`,
        href: "https://www.jukinmedia.com/terms",
        rel: "noopener noreferrer"
      }, "Terms"))), _react["default"].createElement("div", null, _react["default"].createElement("h3", null, "About"), _react["default"].createElement("ul", null, _react["default"].createElement("li", null, _react["default"].createElement("a", {
        onClick: function onClick() {
          return analytics("send", "event", message, "TMB");
        },
        className: `footerUrl`,
        href: "https://www.trustedmediabrands.com/",
        target: "_blank",
        rel: "noopener noreferrer"
      }, "TMB")), _react["default"].createElement("li", null, _react["default"].createElement("a", {
        className: "terms",
        onClick: function onClick() {
          return analytics("send", "event", message, "About");
        },
        className: `footerUrl`,
        href: "https://www.trustedmediabrands.com/company/",
        target: "_blank",
        rel: "noopener noreferrer"
      }, "About"))), _react["default"].createElement("li", null, _react["default"].createElement("a", {
        className: "terms",
        onClick: function onClick() {
          return analytics("send", "event", message, "Brands");
        },
        className: `footerUrl`,
        href: "https://www.trustedmediabrands.com/brands/",
        target: "_blank",
        rel: "noopener noreferrer"
      }, "Brands")), _react["default"].createElement("li", null, _react["default"].createElement("a", {
        className: "terms",
        onClick: function onClick() {
          return analytics("send", "event", message, "Careers");
        },
        className: `footerUrl`,
        href: "https://www.trustedmediabrands.com/careers/",
        target: "_blank",
        rel: "noopener noreferrer"
      }, "Careers")))), _react["default"].createElement("div", {
        className: "copyright mobile"
      }, _react["default"].createElement("img", {
        src: "https://i.imgur.com/QMVRNv4.png",
        style: {
          width: '50px',
          height: '50px',
          position: 'absolute',
          marginTop: '-15px'
        }
      }), _react["default"].createElement("p", null, "\xA9 ", copyright, " ", _react["default"].createElement("a", {
        onClick: function onClick() {
          return analytics("send", "event", message, "JM link");
        },
        href: "/",
        className: 'mobileLogo',
        title: "Jukin Media",
        target: "_blank",
        rel: "noopener noreferrer"
      }, "Trusted Media Brands"))), _react["default"].createElement("div", null, _react["default"].createElement(_index.SocialIcons, null, _react["default"].createElement("a", {
        onClick: function onClick() {
          return analytics("send", "event", message, "Social", "LinkedIn");
        },
        href: "https://www.linkedin.com/company/jukin-media",
        title: "LinkedIn",
        target: "_blank",
        rel: "noopener noreferrer"
      }, _react["default"].createElement(_reactFontawesome.FontAwesomeIcon, {
        icon: ["fab", "linkedin-in"]
      })), _react["default"].createElement("a", {
        onClick: function onClick() {
          return analytics("send", "event", message, "Social", "YouTube");
        },
        href: "https://www.youtube.com/user/JukinMedia",
        title: "Youtube",
        target: "_blank",
        rel: "noopener noreferrer"
      }, _react["default"].createElement(_reactFontawesome.FontAwesomeIcon, {
        icon: ["fab", "youtube"]
      })), _react["default"].createElement("a", {
        onClick: function onClick() {
          return analytics("send", "event", message, "Social", "Facebook");
        },
        href: "https://www.facebook.com/jukinmedia",
        title: "Facebook",
        target: "_blank",
        rel: "noopener noreferrer"
      }, _react["default"].createElement(_reactFontawesome.FontAwesomeIcon, {
        icon: ["fab", "facebook-f"]
      })), _react["default"].createElement("a", {
        onClick: function onClick() {
          return analytics("send", "event", message, "Social", "Instagram");
        },
        href: "http://instagram.com/jukinmedia",
        title: "Instagram",
        target: "_blank",
        rel: "noopener noreferrer"
      }, _react["default"].createElement(_reactFontawesome.FontAwesomeIcon, {
        icon: ["fab", "instagram"]
      })), _react["default"].createElement("a", {
        onClick: function onClick() {
          return analytics("send", "event", message, "Social", "Twitter");
        },
        href: "https://twitter.com/JukinMedia",
        title: "Twitter",
        target: "_blank",
        rel: "noopener noreferrer"
      }, _react["default"].createElement(_reactFontawesome.FontAwesomeIcon, {
        icon: ["fab", "twitter"]
      })))));
    }
  }]);

  return JukinFooter;
}(_react.PureComponent);

exports["default"] = JukinFooter;

_defineProperty(JukinFooter, "propTypes", {
  funkUrl: _propTypes["default"].string.isRequired,
  analytics: _propTypes["default"].func.isRequired,
  message: _propTypes["default"].string.isRequired
});